<template>
    <div>
        <b-modal :id="modalId"
                 @hidden="onModalHidden()"
                 modal-class="modal-otp"
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-body">
                    <div class="wrapper-header">
                        <div class="text-header">
                            <div class="text">
                                <p>{{lbl.otp.title_otp}}</p>
                            </div>
                        </div>
                        <div class="btn-close" @click="cancelOtp()">
                             <img src="@/assets/icon/otp_icon_close@2x.png">
                        </div>
                    </div>
                    <div class="text-send-otp">{{lbl.otp.text_send_otp}}
                        <div>{{getPhoneFormat()}}</div>
                    </div>
                    <div class="text-ref-code">{{lbl.otp.refcode}}
                        <span>{{refcode}}</span>
                    </div>

                    <div class="text-otp">{{lbl.otp.text_enter_otp}}</div>
                    <div>
                        <div class="box-otp">
                            <label for="input-otp">
                                <div class="d-flex justify-content-center">
                                    <div class="box-input-otp">{{otp[0]}}</div>
                                    <div class="box-input-otp">{{otp[1]}}</div>
                                    <div class="box-input-otp">{{otp[2]}}</div>
                                    <div class="box-input-otp">{{otp[3]}}</div>
                                    <div class="box-input-otp">{{otp[4]}}</div>
                                    <div class="box-input-otp">{{otp[5]}}</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <input  type="tel"
                            id="input-otp"
                            class="input-otp-dummy"
                            maxlength="6"
                            v-model="otp"
                            @input="onOtpChange()"
                            @blur="onOtpBlur()">

                    <div class="text-otp-error" v-if="errorText">{{errorText}}</div>
                    <div class="text-otp-time" v-if="!isExpireTime">
                        {{lbl.otp.otp_timeout}} <span class="text-time">{{timeHelper.displayTime}} {{lbl.otp.minute}}</span>
                    </div>
                    <div class="text-otp-time" v-else @click="resendOtp()">
                        {{lbl.otp.text_otp_expired}} <span class="text-time text-underline">{{lbl.otp.resend_otp}}</span>
                    </div>
                    <div class="btn-submit" v-if="!isExpireTime && otp.length == 6" @click="onSubmitOtp()">
                        <div class="btn-txt">
                            {{lbl.otp.btn_confirm}}
                        </div>
                    </div>
                    <div class="btn-submit disabled" v-else>
                        <div class="btn-txt">
                            {{lbl.otp.btn_confirm}}
                        </div>
                    </div>
                    <!-- <div class="otp-line"></div> -->
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import TimerHelper from "@/helper/TimerHelper.js";
import CacheHelper from "@/helper/CacheHelper.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
//service
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//service
import RegisterApi from "@/core/Bioderma/service/RegisterApi.js";
//herlper
import { TrackingService } from "@/helper/TrackingHelper.js";
/**
 * ! This file copy form Food Hunt
 * @property {AlertModalController} controller (required) /components/Modal/Controller/AlertModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "OtpModal",
    props: {
        // busModal: Object,
        controller: Object,
        modalId: String,
    },
    mixins: [LocaleMixin, ErrorApiMixin],
    components: {
        // Button,
    },
    data: function() {
        return {
            busModal: null,

            tel: '',
            contactNumber: '',
            otp: '',
            refcode: '',
            channel: '',

            timeHelper: new TimerHelper(),
            isExpireTime: false,

            errorText: '',

            tracking: new TrackingService(this)
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
        this.timeHelper.initialTimer(90, null, false, false);

        //this.timeHelper.initialTimer(80, null, false, false);
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);
        this.busModal.$on('startOtp', this.startOtp);
        this.busModal.$on('cancelOtp', this.cancelOtp);
    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function() {
            this.showModal();
        },
        showModal: function() {
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        //#region otp
        startOtp: async function(config) {
            this.controller.loadingModal.show();
            this.isExpireTime = false;
            this.contactNumber = config.contactNumber;
            this.refcode = '';
            this.otp = '';
            this.channel = config.channel;
            var success = await this.apiRequestOtp();
            if (success) {
                this.controller.loadingModal.hide();
                this.timeHelper.runTimer(() => {
                    this.setTimeout();
                });

                this.controller.sendCallbackSuccess();
                this.showModal();
            }
        },
        apiRequestOtp: async function() {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(this.contactNumber, this.channel)
                .subscribe((data) => {
                    console.log(data);
                    this.refcode = data.refcode;
                    resolve(true);
                }, (err) => {
                    this.controller.loadingModal.hide();

                    if (err.id == 2078) {
                        this.controller.sendCallbackError(err);
                        // this.controller.alertModal
                        //     .clearText()
                        //     .setMsg("เบอร์โทรซ้ำ")
                        //     .show();
                        // this.controller.alertModal.onClickOk(() => {
                        //     this.controller.sendCallbackError(err);
                        // });
                    } else {
                        this.controller.sendCallbackError(err);
                        this.errorApi(err);
                    }

                    reject(false);
                });
            });
        },

        cancelOtp: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = false;
            this.hide();
            this.controller.sendCallbackCancel();
        },
        onOtpChange: function() {
            this.otp = this.otp.replace(/\D/g, '');
            this.errorText = '';

            if(Util.getMobileOS() == 'iOS'){
                var element = document.getElementById(this.modalId);
                element.firstElementChild.classList.add("ios");
            }
        },
        onOtpBlur: function(){
            if(Util.getMobileOS() == 'iOS'){
                var element = document.getElementById(this.modalId);
                element.firstElementChild.classList.remove("ios");
            }
        },
        setTimeout: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = true;
        },
        validateOtp: function() {
            if (this.otp.length != 6) {
                var errorMsg = this.lbl.otp.otpLength;
                if (this.otp == '') {
                    errorMsg = this.lbl.otp.requireInput;
                }

                this.hide();
                this.controller.alertModal.clearText()
                        .setMsg(errorMsg)
                        .show();
                this.controller.alertModal.onHidden(() => {
                    this.showModal();
                });
                return false;
            }

            return true;
        },
        resendOtp: async function() {
            this.controller.loadingModal.show();
            this.isExpireTime = false;
            // this.tel = config.tel;
            this.refcode = '';
            this.otp = '';
            this.errorText = '';

            await this.apiRequestOtp();

            this.controller.loadingModal.hide();
            this.timeHelper.runTimer(() => {
                this.setTimeout();
            });
        },
        onSubmitOtp: function() {
            if (this.validateOtp()) {
                console.log('otp pass');
                var otpConfig = {
                    contactNumber: this.contactNumber,
                    otp: this.otp,
                    refcode: this.refcode,
                };

                //for register
                if(this.channel == 'register'){
                    this.checkUser(otpConfig);
                    this.tracking.event('popup_otp_register','click_confirm_otp_register');
                }else{
                    this.controller.sendCallbackSubmitOtp(otpConfig);
                }
            }
        },
        checkUser: function(otp){
            var cache = new CacheHelper('session');

            var getFriendCode = "";
            if(cache.getCache('friendcode')){
                getFriendCode = cache.getCache('friendcode');
            }

            this.controller.loadingModal.show();

            RegisterApi.apiCheckUser(this.contactNumber, otp).subscribe((res) =>{
                this.controller.loadingModal.hide();
                console.log("check",res);

                if(!res.success){
                    if(res.code == '404'){
                        cache.setCache('registerOTP', otp);
                        if(getFriendCode){
                            this.$router.push("/register?getFriendCode="+getFriendCode);
                        }else{
                            this.$router.push("/register");
                        }
                    }
                    this.errorText = res.message;
                }else{
                    cache.setCache('registerOTP', otp);
                    cache.setCache('registerPrefill', res.data);
                    if(getFriendCode){
                        this.$router.push("/register?getFriendCode="+getFriendCode);
                    }else{
                        this.$router.push("/register");
                    }
                }

            },(err) => {
                this.controller.loadingModal.hide();
                this.errorApi(err);
            });
        },
        //utility
        getPhoneFormat: function(){
            var telText = Util.contactNumberFormat(this.contactNumber, '-').slice(0, -4) + "xxxx";
            //console.log('tel', telText);
            return telText;
        },
        //#endregion otp
    },
}
</script>
<style lang="scss">
    @import "@/style/base/base.scss";
    @import "@/style/base/baseDisplay.scss";
    @import '@/style/input/BaseButton.scss';
    @import "@/style/modal.scss";
    @import "./OtpModal.scss";

    .modal-otp{
        .modal-dialog{
            width: 100%;
            position: absolute;
            bottom: 0;
            right: 0;
            left: 0;
            margin: auto;

            &.ios{
                bottom: 30vh;
            }

            .modal-content{
                border-top-left-radius: 30px;
                border-top-right-radius: 30px;
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

    }
</style>



